<template>
  <div class="mt-6 md:w-11/12 mx-auto h-full">
    <div v-if="reviews" class="overflow-scroll left-scroll h-full">
      <span class="font-black text-2xl underline mb-2"> Reviews:</span>
      <div v-for="(review, idx) in reviews" :key="idx" class="flex flex-col mb-2">
        <div class= "border-2 border-gray-200 p-4 rounded">
          <div
            class = "mb-2 flex w-full"
            :class = "review.text != '' ? 'border-b-2 pb-2': ''"
            >
            <div class="w-1/2"> Reviewer:
              <div class="font-medium">
                {{ review.author_name }}
              </div>
            </div>
            <div class="w-1/2 flex-col"> Rating:
              <div class="flex">
                <svg v-for="i in 5" :key="i" viewBox="0 0 24 24" :class="i <= review.rating ? 'text-green-500' : 'text-gray-400'" class="h-6 w-6 fill-current">
                  <path d="M8.128 19.825a1.586 1.586 0 0 1-1.643-.117 1.543 1.543 0 0 1-.53-.662 1.515 1.515 0 0 1-.096-.837l.736-4.247-3.13-3a1.514 1.514 0 0 1-.39-1.569c.09-.271.254-.513.475-.698.22-.185.49-.306.776-.35L8.66 7.73l1.925-3.862c.128-.26.328-.48.577-.633a1.584 1.584 0 0 1 1.662 0c.25.153.45.373.577.633l1.925 3.847 4.334.615c.29.042.562.162.785.348.224.186.39.43.48.704a1.514 1.514 0 0 1-.404 1.58l-3.13 3 .736 4.247c.047.282.014.572-.096.837-.111.265-.294.494-.53.662a1.582 1.582 0 0 1-1.643.117l-3.865-2-3.865 2z" />
                </svg>
              </div>
            </div>
          </div>
          <div class="">
            <div class = "italic my-2">
              {{ review.text }}
            </div>
          </div>
          <div
            class = "flex w-full justify-end"
            :class = "review.text != '' ? 'border-t-2 pt-2': ''"
            >
            <div class="w-1/2 font-light text-xs">
              Written: {{ review.relative_time_description }}
            </div>
            <div class="font-light w-1/2 text-xs text-right">
              Review via Google
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <span class="font-black text-2xl underline mb-2"> Reviews: </span>
      <div>We are sorry, {{filteredInstructor.name}} does not have any reviews.</div>
    </div>
  </div>
</template>
<script>
import get from 'lodash.get'
export default {
  name: 'InstructorProfileBody',
  props: {
    name: {
      type: String,
      default: ''
    }
  },
  computed: {
    filteredInstructor () {
      return get(this.$store.state.instructorModule, 'selectedInstructor', null)
    },
    reviews () {
      return get(this.$store.state.instructorModule, 'selectedInstructor.reviews', null)
    }
  }
}
</script>
